<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <div class="col-lg-12">
                <div class="card card-danger card-outline collapsed-card">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <!-- Collapse Button -->
                            <button
                                class="btn btn-secondary"
                                @click="
                                    getGatepassStatusReport(
                                        '/api/generateGatepassStatusReport'
                                    )
                                "
                            >
                                <i class="fa fa-refresh"></i> Refresh
                            </button>
                            &nbsp;
                            <button
                                class="btn btn-secondary"
                                @click="copyTable"
                            >
                                <i class="fas fa-copy"></i> Copy Table
                            </button>
                            &nbsp;
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |From Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.from_date"
                                            placeholder="From date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created |To Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.to_date"
                                            placeholder="To date"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Product:</span
                                        >
                                        <v-select
                                            v-model="params.product"
                                            :options="products"
                                            label="product_name"
                                            :reduce="
                                                (products) =>
                                                    products.product_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Category:</span
                                        >
                                        <v-select
                                            v-model="params.item_category"
                                            :options="linkages"
                                            label="category_name"
                                            :reduce="
                                                (linkages) =>
                                                    linkages.category_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Requirement:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter requirement"
                                            v-model="params.requirement"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >EntryPoint:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.entry_point"
                                        >
                                            <option value="POS">POS</option>
                                            <option value="CARE">CARE</option>
                                            <option value="CRM">CRM</option>
                                            <option value="ECOMMERCE">
                                                ECOMMERCE
                                            </option>
                                            <option value="ONLINE">
                                                ONLINE
                                            </option>
                                            <option value="WACHATBOT">
                                                WHATSAPP CHATBOT
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Campaign Media:</span
                                        >
                                        <v-select
                                            v-model="params.campaign_media"
                                            :options="medias"
                                            label="name"
                                            :reduce="(medias) => medias.id"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Gatepass Status:</span
                                        >
                                        <v-select
                                            v-model="params.status"
                                            :options="gpstatuses"
                                            label="status"
                                            :reduce="
                                                (gpstatuses) =>
                                                    gpstatuses.status
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div
                                    class="col-sm-4"
                                    v-if="params.status == 'Lost'"
                                >
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Turnaway Reason:</span
                                        >
                                        <v-select
                                            v-model="params.turnaway_reason"
                                            :options="reasons"
                                            label="name"
                                            :reduce="(reasons) => reasons.name"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Gatepass Type:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.type"
                                        >
                                            <option value="Sales">Sales</option>
                                            <option value="Service">
                                                Service
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Status Summary:</span
                                        >
                                        <select
                                            v-model="params.summary"
                                            style="width: 100% !important"
                                            class="form-control"
                                        >
                                            <option value="0">Pending</option>
                                            <option value="1">Converted</option>
                                            <option value="2">Lost</option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4" v-if="$gate.isMISAdmin()">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Status Updated On:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.status_updated_on"
                                            placeholder="Status Updated On"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Status Updated From:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.status_updated_from"
                                            placeholder="Status Updated From"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Status Updated To:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="params.status_updated_to"
                                            placeholder="Status Updated To"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search in Status Notes:</span
                                        >
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="params.status_notes"
                                            placeholder="Search Status "
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Assignment Status:</span
                                        >
                                        <select
                                            v-model="params.assignment"
                                            style="width: 100% !important"
                                            class="form-control"
                                        >
                                            <option value="0">
                                                Un-assigned
                                            </option>
                                            <option value="1">Assigned</option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Is Lead Sheet Item?:</span
                                        >
                                        <select
                                            v-model="params.is_leadsheet_item"
                                            style="width: 100% !important"
                                            class="form-control"
                                        >
                                            <option value="0">No</option>
                                            <option value="1">Yes</option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div
                                    class="col-sm-4"
                                    v-if="
                                        $gate.isZonalManager() ||
                                        $gate.isMISAdmin() ||
                                        $gate.isSecondaryMISAdmin() ||
                                        $gate.isCCManager() ||
                                        $gate.isCCAgent() ||
                                        $gate.isOnlineSalesManager() ||
                                        $gate.isOnlineSalesAssociate() ||
                                        $gate.isServiceAdmin()
                                    "
                                >
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Branch:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="params.branch"
                                            multiple
                                        >
                                            <option
                                                v-for="branch in branches"
                                                :value="branch.branch_code"
                                            >
                                                {{ branch.branch }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Phone Number:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter a phone number"
                                            v-model="params.phone_number"
                                            type="number"
                                            min="1000000000"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Lead Name:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter a lead name"
                                            v-model="params.name"
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Created By:</span
                                        >
                                        <v-select
                                            v-model="params.created_by"
                                            :options="salesmen"
                                            label="user_detail"
                                            :reduce="(salesmen) => salesmen.id"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Assigned To:</span
                                        >
                                        <v-select
                                            v-model="params.assigned_to"
                                            :options="salesmen"
                                            label="user_detail"
                                            :reduce="(salesmen) => salesmen.id"
                                        ></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="
                                                getGatepassStatusReport(
                                                    '/api/generateGatepassStatusReport'
                                                )
                                            "
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            Displaying Results with filters: From {{ this.params.from_date }} to
            {{ this.params.to_date }}
            <span v-if="params.entry_point != '' && params.entry_point != null"
                >With</span
            ><span v-if="params.entry_point == '' || params.entry_point == null"
                >without</span
            >
            entrypoint {{ params.entry_point }} for branches {{ params.branch }}
            <br />
            <br />
            <div class="10">
                <div class="row">
                    <div class="col-md-11">
                        <div class="row" align="center">
                            <div class="col-lg-3 col-12">
                                <!-- small box -->
                                <div class="small-box bg-danger">
                                    <div class="inner">
                                        <h4>{{ getTotalCount }}</h4>
                                        <p>Total</p>
                                    </div>
                                    <div class="icon">
                                        <i class="ion ion-person-add"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-3 col-12">
                                <!-- small box -->
                                <div class="small-box bg-warning">
                                    <div class="inner">
                                        <h4>{{ sale_orders }}</h4>
                                        <p>O2POS Booked</p>
                                    </div>
                                    <div class="icon">
                                        <i class="ion ion-pricetag"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-3 col-12">
                                <!-- small box -->
                                <div class="small-box bg-success">
                                    <div class="inner">
                                        <h4>{{ invoiced }}</h4>
                                        <p>O2POS Invoiced</p>
                                    </div>
                                    <div class="icon">
                                        <i class="ion ion-card"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-3 col-12">
                                <!-- small box -->
                                <div class="small-box bg-secondary">
                                    <div class="inner">
                                        <h4>{{ lead_sheet_items }}</h4>
                                        <p>O2CRM Leads</p>
                                    </div>
                                    <div class="icon">
                                        <i class="ion ion-person"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body table-responsive">
                        <table
                            class="table table-hover table-striped table-bordered overflow-auto"
                        >
                            <thead
                                class="thead-light sticky-top top-0"
                                style="
                                    position: sticky !important;
                                    top: 0 !important;
                                "
                            >
                                <tr>
                                    <th>Branch Code</th>
                                    <th>Campaign Name</th>
                                    <th
                                        v-for="gp in gpstatuses"
                                        :key="gp.status"
                                        style="cursor: pointer"
                                        @click="toggleSortOrder(gp.status)"
                                    >
                                        {{ gp.status }}
                                        <i
                                            v-if="sortBy === gp.status"
                                            :class="[
                                                sortAscending
                                                    ? 'fa fa-caret-up'
                                                    : 'fa fa-caret-down',
                                            ]"
                                        ></i>
                                    </th>
                                    <th>Total Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(group, index) in groupedData"
                                    :key="index"
                                >
                                    <td>{{ group.branch_code }}</td>
                                    <td>{{ group.campaign_name }}</td>
                                    <td
                                        v-for="gp in gpstatuses"
                                        :key="gp.status"
                                    >
                                        {{ getStatusCount(group, gp.status) }}
                                    </td>
                                    <td>{{ group.total_count }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th></th>
                                    <th>Total</th>
                                    <th
                                        v-for="gp in gpstatuses"
                                        :key="gp.status"
                                    >
                                        {{ getColumnTotal(gp.status) }}
                                    </th>
                                    <th>{{ getTotalCount }}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="card-footer"></div>
                </div>
            </div>
        </section>
        <!-- /.content -->

        <loading :show="lshow" :label="llabel"> </loading>
        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
import { parse } from "postcss";
import Pagination from "../../pagination.vue";
import loading from "vue-full-loading";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { loading: loading, pagination: Pagination },

    created() {
        this.params.from_date = new Date().toISOString().slice(0, 10);
        this.params.to_date = new Date().toISOString().slice(0, 10);
        this.getCampaignMedias();
        this.getBranches();
        this.getSalesmen();
        this.getLinkages();
        this.getProducts();
        this.getGPStatuses();
        this.getReasons();
        this.getGatepassStatusReport();
    },

    data() {
        return {
            lshow: false,
            llabel: "Updating Leads. Do not close or change this page...",
            status_report: [],
            gpstatuses: [],
            linkages: [],
            products: [],
            salesmen: [],
            branches: [],
            medias: [],
            reasons: [],
            sortBy: "Converted",
            sortAscending: false,
            lead_sheet_items: "-",
            sale_orders: "-",
            invoiced: "-",
            params: new Form({
                status: "",
                from_date: "",
                to_date: "",
                name: "",
                type: "",
                requirement: "",
                campaign_media: "",
                product: "",
                entry_point: "",
                phone_number: "",
                turnaway_reason: "",
                is_leadsheet_item: "",
                item_category: "",
                status_updated_on: null,
                status_updated_from: null,
                status_updated_to: null,
                status_notes: null,
                assignment: "",
                branch: [],
                summary: "",
                results: "",
                created_by: "",
                assigned_to: "",
            }),
        };
    },

    computed: {
        groupedData() {
            const grouped = [];
            const groupKeyMap = new Map();

            this.status_report.forEach((item) => {
                const branchCode = item.branch_code;
                const campaignName = item.campaign_name;
                const campaignKey = `${branchCode}_${campaignName}`;

                if (!groupKeyMap.has(campaignKey)) {
                    groupKeyMap.set(campaignKey, grouped.length);
                    grouped.push({
                        branch_code: branchCode,
                        campaign_name: campaignName,
                        counts: {},
                    });
                }

                const groupIndex = groupKeyMap.get(campaignKey);
                if (!grouped[groupIndex].counts[item.status]) {
                    grouped[groupIndex].counts[item.status] = 0;
                }
                grouped[groupIndex].counts[item.status] += item.count;
            });

            grouped.forEach((group) => {
                group.total_count = Object.values(group.counts).reduce(
                    (sum, count) => sum + count,
                    0
                );
            });

            // Sort the grouped array by the count of 'Converted' status in descending order
            // grouped.sort((a, b) => (b.counts.Converted || 0) - (a.counts.Converted || 0));
            // return grouped;

            const sortedGrouped = [...grouped];

            sortedGrouped.sort((a, b) => {
                const aValue = a.counts[this.sortBy] || 0;
                const bValue = b.counts[this.sortBy] || 0;
                return this.sortAscending ? aValue - bValue : bValue - aValue;
            });

            return sortedGrouped;
        },
        // Calculate the total count for all groups
        getTotalCount() {
            return this.groupedData.reduce(
                (sum, group) => sum + group.total_count,
                0
            );
        },
    },

    methods: {
        reset() {
            this.params.reset();
            this.getGatepassStatusReport();
        },

        toggleSortOrder(status) {
            if (this.sortBy === status) {
                this.sortAscending = !this.sortAscending;
            } else {
                this.sortBy = status;
                this.sortAscending = false;
            }
        },

        copyTable() {
            const table = document.querySelector(".table"); // Select the table element using its class
            const range = document.createRange();
            range.selectNode(table);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand("copy");
            selection.removeAllRanges();

            alert("Table content copied to clipboard!");
        },

        getCampaignMedias() {
            axios.post("/api/getCampaignMedias").then((response) => {
                this.medias = response.data;
            });
        },

        getSalesmen() {
            axios.post("/api/getBranchCallAgents").then((response) => {
                this.salesmen = response.data;
            });
        },

        getReasons() {
            axios.post("/api/getAllTAR").then((response) => {
                this.reasons = response.data;
            });
        },

        getLinkages(url = "/api/getActiveCategoryProductLinks") {
            axios.post(url).then((response) => {
                this.linkages = response.data.data;
            });
        },

        getProducts(url = "/api/getMasterProductList") {
            axios.post(url).then((response) => {
                this.products = response.data;
            });
        },

        getGPStatuses() {
            axios.post("/api/getGPStatuses").then((response) => {
                this.gpstatuses = response.data;
            });
        },

        getStatusCount(group, status) {
            return group.counts[status] || 0;
        },

        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getGatepassStatusReport(url = "/api/generateGatepassStatusReport") {
            axios.post(url, { filters: this.params }).then((response) => {
                this.status_report = response.data.report;
                this.lead_sheet_items = response.data.lead_sheet_items;
                this.sale_orders = response.data.sale_orders;
                this.invoiced = response.data.invoiced;
                // this.configPagination(response.data.data);
            });
        },

        // Calculate the column-wise total for a specific status
        getColumnTotal(status) {
            return this.groupedData.reduce(
                (sum, group) => sum + (group.counts[status] || 0),
                0
            );
        },
    },
};
</script>
